<template>
  <div
    class="font-sans text-dark bg-light antialiased overflow-x-hidden min-h-screen"
  >
    <header
      id="navbar"
      class="fixed w-full top-0 z-50 transition-all duration-300 bg-white shadow-md"
    >
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center py-4">
          <button
            @click="goBack"
            class="flex items-center text-[#0A4DA2] font-medium hover:text-secondary transition-colors"
          >
            <i class="fa fa-arrow-left mr-2"></i>
            <span class="text-lg font-bold">{{ langData.btn.back }}</span>
          </button>

          <!-- 右侧：立即咨询 + 语言切换 -->
          <div class="flex items-center space-x-3">
            <button
              @click="goConsult"
              class="bg-[#0A4DA2] hover:bg-[#0A4DA2]/90 text-white px-6 py-1.5 rounded-full transition-all hover:shadow-lg"
            >
              {{ langData.btn.consult }}
            </button>
            <!-- <button
              @click="toggleLang"
              class="bg-[#0A4DA2] hover:bg-[#0A4DA2]/90 text-white px-5 py-1.5 rounded-full transition-all"
            >
              {{ currentLang === "zh" ? "EN" : "简体" }}
            </button> -->
          </div>
        </div>
      </div>
    </header>

    <main class="pt-24 pb-16">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <!-- 核心：PC 左右布局 / 移动端上下布局 -->
        <div
          class="max-w-8xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden grid md:grid-cols-2 grid-cols-1"
        >
          <!-- 左侧：图片 -->
          <div class="w-full flex items-center justify-center bg-gray-50">
            <img
              :src="imgUrl"
              class="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>

          <!-- 右侧：内容 -->
          <div class="p-8 md:p-12 flex flex-col justify-center">
            <h1
              class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-[#0A4DA2] mb-6"
            >
              {{ currentTitle }}
            </h1>
            <div
              class="text-gray-600 text-base leading-relaxed whitespace-pre-line"
            >
              {{ currentContent }}
            </div>

            <div class="flex flex-wrap gap-3 mt-6">
              <span
                v-for="tag in currentTags"
                :key="tag"
                class="bg-[#0A4DA2]/10 text-[#0A4DA2] px-4 py-1.5 rounded-full text-sm font-medium"
              >
                <i class="fa fa-check-circle mr-1"></i>
                {{ tag }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

const imgUrl = ref("");
const currentLang = ref(localStorage.getItem("siteLang") || "zh");

// 先判断 index 是否合法，不合法直接跳首页
const validIndexList = [1, 2, 3, 4];
const currentIndex = ref(Number(route.query.index) || 0);

// 如果 index 不合法，直接跳转首页，不继续执行
if (!validIndexList.includes(currentIndex.value)) {
  router.replace({ path: "/" });
}

// 只有合法 index 才赋值图片
if (currentIndex.value === 1) {
  imgUrl.value = require("../assets/4.png");
} else if (currentIndex.value === 2) {
  imgUrl.value = require("../assets/1.png");
} else if (currentIndex.value === 3) {
  imgUrl.value = require("../assets/3.png");
} else if (currentIndex.value === 4) {
  imgUrl.value = require("../assets/2.png");
}

const toggleLang = () => {
  currentLang.value = currentLang.value === "zh" ? "en" : "zh";
  // 存入本地存储
  localStorage.setItem("siteLang", currentLang.value);
};

// 立即咨询跳转
const goConsult = () => {
  window.open(
    "https://work.weixin.qq.com/kfid/kfc964776c9b0909cb6",
    "_blank",
    "noopener noreferrer",
  );
};

const languageMap = {
  zh: {
    btn: { back: "返回", consult: "立即咨询" },
    services: {
      1: {
        title: "灵活用工运营服务平台",
        content: `核心模式：系统建设 + 场景运营 + 数据智能三位一体。
服务网络：覆盖全国，专注服务物流、外卖等灵活用工密集行业。

落地效果
某快递闪送平台：骑手 APP 对接平台，秒级自动投保，日均处理保单超 10 万，合规率达 92%，人均月保费下降 18%。
某物流公司：仓配骑手 / 分拣员全覆盖，按单计费，人力成本降 21%，理赔周期从 7 天缩短至 24 小时。

平台核心功能
保险中台：统一对接多家保险公司，提供意外险、雇主责任险、职业伤害险等定制产品。
灵活计费：支持按单 / 按日 / 按周多种模式，精准匹配用工时长。
数据看板：实时查看投保数据、合规报表、成本分析，支撑管理决策。
风控预警：异常投保 / 理赔行为实时监控，降低欺诈风险。`,
        tags: ["灵活用工", "自动投保", "全国覆盖", "风控合规"],
      },
      2: {
        title: "智能理赔 TPA 系统",
        content: `中弘润景智能理赔 TPA 系统是保险科技领域的第三方理赔服务平台，依托 AI、RPA、大数据技术，聚焦保险理赔全流程（报案→受理→审核→定损→赔付→结案），解决传统理赔 “慢、贵、繁、险” 四大痛点，适配寿险、健康险、意外险、责任险等多险种场景。

落地成效（保险公司案例）
某中型寿险公司：对接系统后，理赔时效从 8 天降至 3 天（缩短 62.5%），客户满意度从 70% 提升至 92%（提升 31.4%），理赔人力成本减少 40%，骗保率从 6% 降至 1.2%。
某大型健康险公司：全量线上化后，小额医疗案件自动赔付率达 85%，平均处理时效 1.5 天，客户满意度提升至 95%，年节省理赔成本超千万元。`,
        tags: ["智能理赔", "AI自动化", "降本提效", "反欺诈"],
      },
      3: {
        title: "数字化教学平台",
        content: `为教育机构打通课消 / 学情数据闭环，实现教学效率提升30%、续课率增长25%，驱动教学标准化、运营精细化、服务个性化。

落地成效（教育机构案例）
某上市机构：接入平台后，课消实时同步，对账周期从 7 天缩至 1 天；学情报告自动生成，教师效率提升 32%；续课率从 58% 升至 73%（增长 25.9%），年营收增加超千万元。
某素质教育集团：全链路数字化后，排课时间从 3 天减至 2 小时；家校沟通效率提升 70%，家长满意度达 91%；续课率增长 28%，学员流失率下降 40%。`,
        tags: ["教学数字化", "课消闭环", "续课提升", "家校互通"],
      },
      4: {
        title: "系统集成与数据中台服务",
        content: `中弘润景深耕金融科技领域，针对第三方支付机构业务痛点，打造“系统整合+数据治理+智能应用”一体化服务体系。
服务适配第三方支付全场景，涵盖聚合支付、线上收单、线下结算、跨境支付等核心业务，凭借成熟的技术架构、专业的实施团队与丰富的行业落地经验，兼顾系统稳定性、数据安全性与业务可扩展性，助力第三方支付机构降本、提效、合规、增收。

落地成效（第三方支付机构案例）
- 某中型第三方支付机构：接入系统集成与数据中台服务后，打通6大业务系统、12个支付渠道，交易效率提升52%，峰值时段无卡顿；对账时长从原来的8小时缩短至2.4小时（缩短70%），对账准确率达99.95%，人工对账人力减少65%，年节省运营成本超800万元，合规风控能力显著提升，顺利通过监管专项检查。
- 某聚合支付机构：搭建统一数据中台后，实现多渠道数据实时整合，交易数据响应速度提升60%，对账效率提升75%；依托数据中台优化风控模型，欺诈交易识别率提升85%，客户投诉率下降50%，业务规模半年内增长40%。`,
        tags: ["系统集成", "数据中台", "支付合规", "效率提升"],
      },
    },
  },
  en: {
    btn: { back: "Back", consult: "Consult Now" },
    services: {
      1: {
        title: "Flexible Insurance Platform",
        content: `Core Model: System Development + Scenario Operation + Data Intelligence.
Service Network: Nationalwide coverage, focusing on logistics, delivery and other flexible employment-intensive industries.

Implementation Results
A Express & Delivery Platform: Rider APP connected to the platform, second-level automatic insurance, daily policies over 100,000, compliance rate 92%, monthly premium per capita down 18%.
A Logistics Company: Full coverage for warehouse riders and sorters, pay-per-order, labor costs down 21%, claim cycle reduced from 7 days to 24 hours.

Core Functions
Insurance Middle Office: Unified connection with multiple insurers, providing accident insurance, employer liability, occupational injury insurance.
Flexible Billing: Support per-order / daily / weekly modes, accurately matching employment duration.
Data Dashboard: Real-time insurance data, compliance reports, cost analysis.
Risk Control: Real-time monitoring of abnormal insurance / claims to reduce fraud.`,
        tags: [
          "Flexible Employment",
          "Auto Insurance",
          "National Coverage",
          "Risk Control",
        ],
      },
      2: {
        title: "TPA Service",
        content: `Zhonghong Runjing TPA Service is a third-party claims service platform powered by AI, RPA and big data. It covers the full claims process: Reporting → Acceptance → Review → Assessment → Payment → Closure, solving the four pain points of traditional claims: Slow, Expensive, Complex, Risky. Supports life, health, accident, liability insurance.

Implementation Results (Insurance Cases)
A Medium Life Insurance Company: Claims time reduced from 8 days to 3 days (-62.5%), customer satisfaction up from 70% to 92% (+31.4%), claims labor cost down 40%, fraud rate down from 6% to 1.2%.
A Large Health Insurance Company: 85% auto-payment for small medical cases, average 1.5-day processing, satisfaction up to 95%, annual cost savings over 10 million RMB.`,
        tags: [
          "Intelligent Claims",
          "AI Automation",
          "Cost Reduction",
          "Anti-Fraud",
        ],
      },
      3: {
        title: "Digital Platform",
        content: `Connects course consumption and learning data closed-loop for education institutions, improving teaching efficiency by 30% and renewal rate by 25%, driving teaching standardization, refined operation and personalized service.

Implementation Results (Education Cases)
A Listed Institution: Real-time course consumption sync, reconciliation from 7 days to 1 day; auto learning reports, teacher efficiency +32%; renewal rate from 58% to 73% (+25.9%), annual revenue +10 million RMB.
A Quality Education Group: Scheduling time from 3 days to 2 hours; parent communication +70%, satisfaction 91%; renewal +28%, student churn -40%.`,
        tags: [
          "Digital Teaching",
          "Data Closed-Loop",
          "Renewal Boost",
          "Home-School",
        ],
      },
      4: {
        title: "System Integration",
        content: `Zhonghong Runjing focuses on fintech, providing an integrated service system: System Integration + Data Governance + Intelligent Applications for payment institutions.
Covers aggregate payment, online acquiring, offline settlement, cross-border payment. With stable architecture, professional team and rich experience, we help payment institutions reduce costs, improve efficiency, ensure compliance and grow revenue.

Implementation Results (Payment Cases)
- A Medium Payment Institution: 6 business systems & 12 channels integrated, transaction efficiency +52%, reconciliation from 8h to 2.4h (-70%), accuracy 99.95%, labor -65%, annual cost saving 8 million RMB, passed regulatory inspection.
- An Aggregate Payment Firm: Real-time multi-channel data integration, response +60%, reconciliation +75%; fraud detection +85%, complaints -50%, business scale +40% in 6 months.`,
        tags: [
          "System Integration",
          "Data Middle Office",
          "Payment Compliance",
          "Efficiency",
        ],
      },
    },
  },
};

const langData = computed(() => languageMap[currentLang.value]);

// 这里使用 currentIndex
const currentTitle = computed(
  () => langData.value.services[currentIndex.value]?.title || "",
);
const currentContent = computed(
  () => langData.value.services[currentIndex.value]?.content || "",
);
const currentTags = computed(
  () => langData.value.services[currentIndex.value]?.tags || [],
);

const goBack = () => {
  router.go(-1);
};

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.8s ease-in-out;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
